export default __webpack_public_path__ + "static/media/icone-multilingue.7136fdb9.svg";